<div [ngClass]="['chatbot-message',message.role === 'assistant' ? 'message-left':'message-right']">
    @if (message.role === 'assistant') {
        <div class="chatbot-avatar">
            <img src="/assets/img/chatBot/gerd.png" alt="Gerd">
        </div>
        <markdown class="chatbot-message-md" [data]="message.content"></markdown>
    } @else {
        <p>{{ message.content }}</p>
    }
</div>
